<template>
  <div class="row mt-3" v-if="policy.renovations.length" id="lista-renovacoes">
    <div class="col-12 mb-3">
      <h5>
        <div class="form-subheader"><span>Renovações</span></div>
      </h5>
    </div>

    <div class="col-12 mb-3">

      <table class="pretty admin mb-3 shadow">
        <thead>
          <tr>
            <th>N.</th>
            <th>Tomador</th>
            <th>Status</th>
            <th>Data/Hora</th>
            <th>Usuário</th>
            <th>Ação</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="policyRenovation in policy.renovations" :key="policyRenovation.id">
            <td>
              <a class="btn" @click="redirectRenovation(policyRenovation)">
                {{ getNameRenovation(policyRenovation) }}
              </a>
            </td>
            <td>{{ policyRenovation.policy_origin.policy_holder_document | formatDocument }} - {{ policyRenovation.policy_origin.policy_holder_name }}</td>
            <td>{{ policyRenovation.status.translate }}</td>
            <td>{{ formatDateTimeFromISO(policyRenovation.created_at) }}</td>
            <td>{{ policyRenovation.user ? policyRenovation.user.name : '' }}</td>
            <td>
                <i @click="redirectRenovation(policyRenovation)"
                  v-b-tooltip.hover title="Visualizar" class="fas fa-eye icon-btn mx-1 small align-self-center"></i>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import dateFormatterMixin from "@/mixins/dateFormatter";
import commomsHelper from "@/mixins/commomsHelper";

export default {
  name: "RenovationsData",
  props: {
    policy: {
      type: Object,
      required: true
    }
  },
  mixins: [
    dateFormatterMixin,
    commomsHelper,
  ],
  computed: {
    filteredRenovations() {
      return this.policy.renovations.filter(policyRenovation => {
        return policyRenovation.policy_id ||
          (policyRenovation.quotation &&
            policyRenovation.quotation.policies &&
            policyRenovation.quotation.policies[0] &&
            policyRenovation.quotation.policies[0].id);
      });
    }
  },

  methods: {
    redirectRenovation(policyRenovation) {
      if (policyRenovation.policy_id) {
        this.redirect('details-policy', { policyId: policyRenovation.policy_id });

      } else if (policyRenovation.policy_origin) {
        this.$router.push({ name: 'kanban-renewal', query: { policyNumber: policyRenovation.policy_origin.number } });
      }

    },
    redirect(routeName, params = null) {
      this.$router.push({ name: routeName, params: params });
    },
    getNameRenovation(policyRenovation) {
      if (policyRenovation.policy) {
        return `APÓLICE N. ${policyRenovation.policy.number}`;
      } else if (policyRenovation.status_id == this.statusQuotationTypes.CANCELED) {
        return 'CANCELADA';
      } else {
        return 'EM RENOVAÇÃO';

      }
    }
  }
};
</script>

<style></style>
